import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MAIN_WEBSITE_URL } from '@/mocks/site';
import CategoryDropdown from './CategoryDropdown';

export default function Hero() {
  const { t } = useTranslation();

  const popular = [
    { label: 'USFans Spreadsheet', to: '/usfans-spreadsheet-guide', internal: true },
    { label: 'USFans Review', to: '#review', internal: false },
    { label: 'USFans Shipping Cost', to: '#shipping', internal: false },
    { label: 'USFans Legit', to: '#safety', internal: false },
  ];

  return (
    <section className="relative flex min-h-[92vh] items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20premium%20e-commerce%20dashboard%20concept%20with%20a%20tablet%20showing%20a%20clean%20product%20grid%20beside%20neatly%20arranged%20colorful%20folded%20clothing%20sneakers%20and%20accessories%20on%20a%20warm%20beige%20linen%20surface%2C%20soft%20daylight%20from%20the%20left%2C%20fresh%20editorial%20aesthetic%2C%20warm%20earthy%20tones%20with%20sage%20green%20and%20terracotta%20accents%2C%20high%20detail%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-01&orientation=landscape&nocache=true"
          alt="USFans spreadsheet resources and product catalog"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-28 md:py-36 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 border border-background-50/30 px-4 py-1.5 text-xs font-semibold tracking-widest text-background-50 backdrop-blur">
          <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-300">
            <i className="ri-sparkling-2-line text-sm" aria-hidden="true"></i>
          </span>
          {t('hero.eyebrow')}
        </p>

        <h1 className="mx-auto mt-6 max-w-4xl font-heading text-3xl md:text-5xl font-extrabold leading-tight tracking-tight text-background-50">
          {t('hero.title')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
          {t('hero.description')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={MAIN_WEBSITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            {t('hero.btnSpreadsheet')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base" aria-hidden="true"></i>
            </span>
          </a>
          <a
            href={MAIN_WEBSITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-foreground-950 hover:bg-accent-600 transition-colors cursor-pointer"
          >
            {t('hero.btnBuyNow')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line text-base" aria-hidden="true"></i>
            </span>
          </a>
        </div>

        <div className="mt-8">
          <CategoryDropdown />
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          <span className="text-xs text-background-100/80">{t('hero.popular')}</span>
          {popular.map((item) =>
            item.internal ? (
              <Link
                key={item.label}
                to={item.to}
                className="whitespace-nowrap rounded-full bg-background-50/10 border border-background-50/25 px-3 py-1 text-xs text-background-50 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.to}
                className="whitespace-nowrap rounded-full bg-background-50/10 border border-background-50/25 px-3 py-1 text-xs text-background-50 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ),
          )}
        </div>
      </div>
    </section>
  );
}